import { createBrowserClient } from '@nokowazzi/supabase-client';
import { env } from '../env';

/**
 * 어드민용 Supabase 클라이언트 — 용도는 Auth 세션 + Storage 서명 업로드/공개 URL만.
 * 데이터 접근은 전면 /v1/admin/** API 경유 (CLAUDE.md 정합성 고정 사항).
 */
export const supabase = createBrowserClient({
  url: env.VITE_SUPABASE_URL,
  anonKey: env.VITE_SUPABASE_ANON_KEY,
});
